import React from "react";
import { default as MuiContainer } from "@mui/material/Container";
import { ContainerProps as MuiContainerProps } from "@mui/material/Container";

export type WcContainerProps = MuiContainerProps;

export const WcContainer = (props: WcContainerProps) => <MuiContainer {...props}></MuiContainer>;

export default WcContainer;
